import { render, staticRenderFns } from "./privacy_page.vue?vue&type=template&id=85c20d52&"
import script from "./privacy_page.vue?vue&type=script&lang=js&"
export * from "./privacy_page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports